import type {
  GetProductPermissionsQuery,
  ProductWithPermissionsFragment,
} from '../models/graphql-types/operations';

export const mapAllowedFavoriteProductCodes = (products: GetProductPermissionsQuery['products']) =>
  products == null
    ? []
    : products
        .filter((product): product is ProductWithPermissionsFragment =>
          Boolean(product?.productCode && product.permission?.canDisplay),
        )
        .map((product) => product.productCode)
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
